module.exports = __webpack_public_path__ + "static/media/about.22889fb2.png";